import { RouteConfig } from 'vue-router'

const InviteTeacherPage = () => import('../views/InviteTeacherPage.vue')
const InviteTeacherFeedBackPage = () => import('../views/InviteTeacherFeedBackPage.vue')

export const inviteTeacherRoute: RouteConfig = {
  path: '/invite-teacher-join-class',
  name: 'InviteTeacherPage',
  component: InviteTeacherPage,
}

export const inviteTeacherFeedBackRoute: RouteConfig = {
  path: '/invite-teacher-feed-back',
  name: 'InviteTeacherFeedBackPage',
  component: InviteTeacherFeedBackPage,
}

export default [inviteTeacherRoute, inviteTeacherFeedBackRoute]
